<template>
	<vx-card
		no-shadow
		card-border
		class="custom-height"
		:title="title ? $t('TimeWindow.AssignedTimeWindows') + ' ' + assignedTimeWindows.length : ''"
	>
		<template v-if="configColumns" slot="actions">
			<div class="flex flex-row justify-between">
				<vx-tooltip
					class="cursor-pointer"
					color="primary"
					position="bottom"
					delay=".1s"
					:title="$t('TimeWindow.AssignTimeWindows')"
					:text="$t('TimeWindow.AssignTimeWindowTooltip')"
				>
					<vs-button
						class="ml-1"
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-plus"
						:disabled="activeAlert2"
						@click.prevent="showTimeWindowList()"
					></vs-button>
				</vx-tooltip>
				<vx-tooltip
					class="cursor-pointer"
					color="primary"
					position="bottom"
					delay=".1s"
					:title="$t('Crud.Delete')"
					:text="$t('TimeWindow.DeleteAllTimeWindows')"
				>
					<vs-button
						v-if="remove"
						class="ml-1"
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-trash"
						@click.stop="openDeleteAllConfirm"
						v-show="assignedTimeWindows.length > 0"
					></vs-button>
				</vx-tooltip>

				<vs-dropdown vs-custom-content :vs-trigger-click="false" class="cursor-pointer">
					<vs-button
						class="ml-1"
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-layout"
					></vs-button>
					<vs-dropdown-menu :style="{width: windowWidth > 620 ? '30%' : '50%'}">
						<vx-card no-shadow :title="$t('AssignedTeams.Columns')">
							<p>{{ $t("AssignedTeams.ColumnsText") }}</p>
							<ul :class="{'demo-alignment': windowWidth > 620}">
								<li>
									<vs-checkbox v-model="checkBoxID">ID</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxName" disabled>{{
										$t("Routing.Table.Name")
									}}</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxDescription">{{ $t("Description") }}</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxCron">{{ "Cron" }}</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxDuration">{{
										$t("TimeWindow.Duration")
									}}</vs-checkbox>
								</li>
							</ul>
						</vx-card>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
		</template>
		<vue-perfect-scrollbar class="scroll-area" :settings="settings">
			<vs-table
				max-items="100"
				pagination
				:data="assignedTimeWindowsFilter"
				search
				v-if="assignedTimeWindowsFilter.length > 0"
			>
				<template slot="thead">
					<vs-th v-show="checkBoxID">ID</vs-th>
					<vs-th v-show="checkBoxCron">{{ "Cron" }}</vs-th>
					<vs-th v-show="checkBoxName">{{ $t("Name") }}</vs-th>
					<vs-th v-show="checkBoxDescription">{{ $t("Description") }}</vs-th>
					<vs-th v-show="checkBoxDuration">{{ $t("TimeWindow.Duration") }}</vs-th>
					<vs-th>{{ $t("BreakTable.Action") }}</vs-th>
				</template>

				<template slot-scope="{data}">
					<vs-tr :key="indextr" v-for="(tr, indextr) in data">
						<vs-td v-show="checkBoxID" :data="data[indextr].id">
							{{ data[indextr].id }}
						</vs-td>
						<vs-td v-show="checkBoxCron" :data="data[indextr].id">
							{{ data[indextr].cron }}
						</vs-td>
						<vs-td v-show="checkBoxName" :data="data[indextr].id">
							{{ data[indextr].name | capitalize }}
						</vs-td>
						<vs-td v-show="checkBoxDescription" :data="data[indextr].id">
							{{ data[indextr].description }}
						</vs-td>
						<vs-td v-show="checkBoxDuration" :data="data[indextr].id">
							{{ data[indextr].duration }}
						</vs-td>
						<vs-td :data="data[indextr].id">
							<feather-icon
								v-if="remove"
								:title="$t('Crud.Delete')"
								size="small"
								icon="TrashIcon"
								svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
								@click="removeAssignedTimeWindow(data[indextr].id)"
							/>

							<feather-icon
								v-if="redirect"
								:title="$t('View') + ' ' + $t('Information')"
								size="small"
								icon="ExternalLinkIcon"
								svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
								class="ml-2"
								@click="goTo(data[indextr].id)"
							/>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
			<p v-else-if="activeAlert2">
				<vs-alert
					class="mt-2"
					style="overflow-y: auto"
					color="warning"
					:active.sync="activeAlert2"
					:title="$t('TimeWindow.AssignTimeWindows')"
				>
					{{ $t("TimeWindow.ThereAreCurrentlyNoTimeWindowsAvailable") }}
					<span
						class="text-inherit underline"
						style="cursor: pointer"
						@click.prevent="goRouter('app-time-window-create')"
					>
						<feather-icon class="cursor-pointer underline" icon="PlusCircleIcon" svgClasses="h-4 w-4" />
						{{ $t("Teams.Form.Add") + " " + $t("TimeWindow.TimeWindow") }}
					</span>
				</vs-alert>
			</p>
			<p v-else>
				{{ $t("TimeWindow.NoAssignedTimeWindows") }}
			</p>
		</vue-perfect-scrollbar>
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="$t('TimeWindow.ListOfTimeWindows')"
			:active.sync="timeWindowMounted"
		>
			<time-window-list v-if="timeWindowMounted" ref="TimeWindowList" :customConfig="timeWindowListConfig">
				<div class="is-stuck" style="background: white">
					<vx-card
						ref="filterCard"
						:title="$t('Filters')"
						class="user-list-filters mb-8"
						no-shadow
						card-border
					>
						<template slot="actions">
							<div class="form-header-inner">
								<vs-button
									:size="iconSize"
									class="ml-2"
									id="btn-locate-visit-point"
									icon-pack="feather"
									icon="icon-check"
									:title="$t('VisitPoints.Assig') + ' ' + $t('Routing.Title.Selection')"
									:disabled="getCheckedTimeWindows.length <= 0"
									@click.prevent="setAssignedTimeWindow()"
									>{{
										windowWidth > 620
											? $t("VisitPoints.Assig") + " " + $t("Routing.Title.Selection")
											: null
									}}
								</vs-button>
							</div>
						</template>
						<div class="vx-row">
							<div class="vx-col w-full md:w-1/4">
								<label class="vs-input--label">{{ $t("SearchBy") }}</label>
								<v-select
									v-model="searchField"
									:clearable="false"
									:options="searchOptions"
									name="country"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
									class="md:mb-1 mb-4"
								>
									<template v-slot:no-options="{search, searching}">
										<template v-if="searching">
											{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
										</template>
										<template v-else>
											{{ $t("NoResultsFound") }}
										</template>
									</template>
								</v-select>
							</div>
							<div class="vx-col w-full md:w-1/2">
								<div class="vx-row">
									<div class="vx-col w-full md:w-1/1">
										<tags-input
											class="w-full mt-2 md:mt-6"
											element-id="tags"
											v-model="searchQuery"
											add-tags-on-comma
											add-tags-on-blur
											:title="$t('SearchSeparatedByCommas') + '.'"
											:placeholder="$t('Teams.Form.Add') + ' ' + searchField.label"
											:typeahead="true"
											@keyup.enter="searchAssignedTimeWindow"
										></tags-input>
									</div>
								</div>
							</div>
							<div class="vx-col w-full md:w-1/4">
								<div class="flex items-center mt-2 md:mt-6">
									<vs-button
										:size="iconSize"
										:title="$t('VisitPoints.Search')"
										class="ml-2"
										icon-pack="feather"
										icon="icon-search"
										@click.prevent="searchAssignedTimeWindow"
										>{{ windowWidth > 620 ? $t("VisitPoints.Search") : null }}
									</vs-button>
									<vs-button
										:size="iconSize"
										:title="$t('Refresh')"
										class="ml-2"
										icon-pack="feather"
										icon="icon-refresh-cw"
										@click="refreshTimeWindow"
										>{{ windowWidth > 620 ? $t("Refresh") : null }}
									</vs-button>
								</div>
							</div>
						</div>
					</vx-card>
				</div>
				<vs-divider class="d-theme-border-grey-light" />
			</time-window-list>
		</vs-popup>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleTimeWindow from "@/store/time-window/moduleTimeWindow.js";
import TimeWindowList from "./TimeWindowList.vue";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

export default {
	name: "AssignedTimeWindowList",
	mixins: [generalPurposeMixin],
	props: {
		time_window_ids: {
			type: Array,
			default: () => [],
		},
		title: {
			type: Boolean,
			default: () => true,
		},
		add: {
			type: Boolean,
			default: () => true,
		},
		remove: {
			type: Boolean,
			default: () => true,
		},
		configColumns: {
			type: Boolean,
			default: () => true,
		},
		redirect: {
			type: Boolean,
			default: () => false,
		},
		capacities: {
			type: Array,
			default: () => [],
		},
		isAssignedTimeWindows: {
			type: Boolean,
			default: () => true,
		},
	},
	components: {
		vSelect,
		VuePerfectScrollbar,
		TimeWindowList,
	},
	data() {
		return {
			timeWindowMounted: false,
			searchQuery: [],
			searchField: {value: "Id", label: "Id"},
			model: null,
			searchQueryVPList: "",
			checkBoxID: true,
			checkBoxName: true,
			checkBoxDescription: true,
			checkBoxCron: false,
			checkBoxDuration: false,
			timeWindowListFetched: false,
			activeAlert2: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			timeWindowListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: ["id", "name", "description", "cron", "duration"],
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: false,
				showActions: false,
				filterHead: false,
				showPopup: true,
			},
		};
	},
	async created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleTimeWindow.isRegistered) {
			this.$store.registerModule("moduleTimeWindow", moduleTimeWindow);
			moduleTimeWindow.isRegistered = true;
		}
	},
	mounted() {
		this.searchQuery = [];
		if (this.time_window_ids && this.time_window_ids.length > 0 && this.isAssignedTimeWindows) {
			this.getTimeWindow(this.time_window_ids);
		}
	},
	computed: {
		assignedTimeWindows() {
			return this.$store.state.moduleTimeWindow.assignedTimeWindows;
		},
		assignedTimeWindowsFilter() {
			const data = this.$store.state.moduleTimeWindow.assignedTimeWindows;
			if (!this.searchQueryVPList || this.searchQueryVPList.trim().length <= 0) {
				return data;
			}
			return data.filter((r) => {
				return (
					r.name.toLowerCase().includes(this.searchQueryVPList.toLowerCase()) ||
					(r.id + "").includes(this.searchQueryVPList)
				);
			});
		},
		searchOptions() {
			return [
				{value: "ID", label: "Id"},
				{value: "Name", label: this.$t("Name")},
			];
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		getCheckedTimeWindows() {
			return this.$store.state.moduleTimeWindow.checkedTimeWindows;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		removeAssignedTimeWindow(id) {
			this.$store.commit("moduleTimeWindow/REMOVE_ASSIGNED_TIME_WINDOW", id);
		},
		refreshTimeWindow() {
			this.$refs.TimeWindowList.refresh();
			this.searchQuery = [];
			this.searchField = {value: "Id", label: "Id"};
		},
		getTimeWindow() {
			this.openLoading();
			this.$store
				.dispatch("moduleTimeWindow/timeWindowAssigned", {
					order_by: ["id"],
					sort: "desc",
					id: this.time_window_ids,
				})
				.then((res) => {
					this.$emit("finishLoadEmit", true);
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		openDeleteAllConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("TimeWindow.DeleteAllText") + ` "${this.$t("TimeWindow.TimeWindow")}"`,
				accept: this.deleteAll,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAll() {
			this.$store.commit("moduleTimeWindow/REMOVE_ALL_ASSIGNED_TIME_WINDOW");
		},
		goTo(timeWindowId) {
			this.$router.push(`/apps/time-window/time-window-view/${timeWindowId}`);
		},
		searchAssignedTimeWindow() {
			this.$refs.TimeWindowList.searchAssignedTimeWindow(this.searchField.value, this.searchQuery, 1);
		},
		setAssignedTimeWindow() {
			let selectedRows = [...this.getCheckedTimeWindows];
			this.$store.commit("moduleTimeWindow/SET_ASSIGNED_TIME_WINDOW", selectedRows);
			this.timeWindowMounted = false;
			this.searchQuery = [];
		},
		async showTimeWindowList() {
			if (this.timeWindowListFetched) {
				this.timeWindowMounted = true;
				return;
			}
			this.timeWindowListFetched = true;
			try {
				const res = await this.$store.dispatch("moduleTimeWindow/findAll");
				if (res.data.length > 0) {
					this.activeAlert2 = false;
					this.timeWindowMounted = true;
				} else {
					this.activeAlert2 = true;
				}
			} catch (err) {
				console.error(err);
			}
		},
	},
	watch: {
		timeWindowMounted(val) {
			if (!val) {
				this.model = null;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
#resource-create-tab-info {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 400px;
	max-height: 450px;
}

.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}

.con-vs-dropdown--menu {
	z-index: 54000 !important;
}
.is-stuck {
	position: fixed;
	top: 52px;
	inset-inline-start: 0;
	margin-inline-start: 30px;
	width: calc(100% - 80px);
	z-index: 14;
}
.form-header-inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>
